import React, { useCallback, useState } from 'react';

import Select, { components } from 'react-select';
import styled from 'styled-components';
import { StyledGrid } from 'styles/common';

import { GOAL_VISIBILITY_OPTIONS, POST_VISIBILITY_TYPES } from 'constants/ProjectConstants';
import { PrivateViewIcon, PublicViewIcon, StyledIconV2 } from 'constants/icons';
import theme from 'constants/theme';

import { Typography4 } from 'uiToolkit/Typography';

const options = [
  {
    value: POST_VISIBILITY_TYPES.private.name,
    label: 'Private',
  },
  {
    value: POST_VISIBILITY_TYPES.global.name,
    label: 'Public',
  },
];

const SelectWrap = styled.div``;

export const VisibilityOption = (props) => {
  const { Option } = components;
  return (
    <Option {...props}>
      <StyledGrid container alignItems="center">
        {props?.data?.value === POST_VISIBILITY_TYPES.private.name ? (
          <StyledIconV2 size="fixed12px" rightGutter={1}>
            <PrivateViewIcon />
          </StyledIconV2>
        ) : (
          <StyledIconV2 size="fixed12px" rightGutter={1}>
            <PublicViewIcon />
          </StyledIconV2>
        )}
        <Typography4 style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: '85%' }}>
          {props.data.label}
        </Typography4>
      </StyledGrid>
    </Option>
  );
};

export const SingleValueOption = (props) => {
  const { SingleValue } = components;
  return (
    <SingleValue {...props}>
      <StyledGrid style={{ minWidth: '9rem' }} container alignItems="center">
        {props?.data?.value === POST_VISIBILITY_TYPES.private.name ? (
          <StyledIconV2 size="fixed12px" rightGutter={1} color={theme.palette.icons.blackv1}>
            <PrivateViewIcon />
          </StyledIconV2>
        ) : (
          <StyledIconV2 size="fixed12px" rightGutter={1} color={theme.palette.icons.blackv1}>
            <PublicViewIcon />
          </StyledIconV2>
        )}
        <Typography4
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: props.selectProps.isGoalDetailSection
              ? '92%'
              : props.selectProps.isCreateGoalFormOld
                ? '40%'
                : '85%',
          }}
        >
          {props.data.label}
        </Typography4>
      </StyledGrid>
    </SingleValue>
  );
};

const VisibilityField = ({ taskDetails, updateTask }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  const handleVisibilityChange = (data) => {
    const newTask = { ...taskDetails, visibilityType: data.value };
    updateTask(newTask, false);
  };

  const selectedValue = GOAL_VISIBILITY_OPTIONS.find(({ value }) => value === taskDetails?.visibilityType) || null;

  return (
    <SelectWrap onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Select
        menuShouldScrollIntoView={false}
        value={selectedValue}
        options={GOAL_VISIBILITY_OPTIONS}
        components={{
          Option: VisibilityOption,
          SingleValue: SingleValueOption,
        }}
        onChange={handleVisibilityChange}
        placeholder="Select Visibility"
        isGoalDetailSection
        isHovered={isHovered}
        styles={customStyles}
      />
    </SelectWrap>
  );
};

const customStyles = {
  control: (base, { selectProps: { isHovered } }) => ({
    ...base,
    width: '100%',
    border: isHovered ? '1px solid hsl(0, 0%, 80%)' : '1px solid transparent',
    cursor: 'pointer',
  }),
  indicatorsContainer: (base, { selectProps: { isHovered } }) => ({
    ...base,
    visibility: isHovered ? 'visible' : 'hidden',
  }),
};

export default VisibilityField;
